export function ExpandoToggle() {
    return {
        require: '^tnExpando',
        restrict: 'A',
        transclude: true,
        replace: true,
        template:
            '<div class="expando_head" ng-click="toggleExpando()" ng-transclude></div>',
        link: function (scope, element, attrs, expandoController) {
            scope.toggleExpando = expandoController.toggle;
        },
    };
}
